import { render, staticRenderFns } from "./LibraryOfGoods.vue?vue&type=template&id=a46b1d74&scoped=true"
import script from "./LibraryOfGoods.vue?vue&type=script&lang=js"
export * from "./LibraryOfGoods.vue?vue&type=script&lang=js"
import style0 from "./LibraryOfGoods.vue?vue&type=style&index=0&id=a46b1d74&prod&lang=scss&scoped=true"
import style1 from "./LibraryOfGoods.vue?vue&type=style&index=1&id=a46b1d74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46b1d74",
  null
  
)

export default component.exports